<template>
    <div class="col-sm-4" v-if="can('ticket.*')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Sales")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/cashier/dashboard-one/ticketsTab" tag="li" v-if="can('ticket.buy')">
                        <a href="#" title="">{{i18n("Cashier's workplace")}}</a>
                    </router-link>
                    <li v-else>
                        <a href="#" @click.prevent>{{i18n("Cashier's workplace")}}</a>
                    </li>
                    <li>
                        <ul class="list-unstyled sub-menu">
                            <router-link to="/cashier/dashboard-one/ticketsTab" tag="li" v-if="can('ticket.buy')">
                                <a href="#" title="">{{i18n("Ticket selling")}}</a>
                            </router-link>
                            <router-link to="/cashier/dashboard-one/bookTicketTab" tag="li" v-if="can('ticket.buy_booked')">
                                <a href="#" title="">{{i18n("Armor redemption")}}</a>
                            </router-link>
                            <router-link to="/cashier/dashboard-one/returnTicketTab" tag="li" v-if="can('ticket.return')">
                                <a href="#" title="">{{i18n("Ticket return")}}</a>
                            </router-link>
                            <router-link to="/cashier/dashboard-one/restoreTicketTab" tag="li" v-if="can('ticket.return')">
                                <a href="#" title="">{{i18n("Restore ticket")}}</a>
                            </router-link>
                            <router-link to="/cashier/dashboard-one/baggageSellingTab" tag="li" v-if="can('baggage-shipping.index')">
                                <a href="#" title="">{{i18n("Baggage selling")}}</a>
                            </router-link>
                            <router-link to="/cashier/dashboard-one/baggageReturnTab" tag="li" v-if="can('baggage-shipping.index')">
                                <a href="#" title="">{{i18n("Baggage return")}}</a>
                            </router-link>
                        </ul>
                    </li>
                    <router-link to="/" tag="li" v-if="can('sales.myreport')">
                        <a href="#" title="">{{i18n("Sales reporting")}}</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SalesCard"
    }
</script>

<style scoped>

</style>
